import PddSpecification from './FormItemSpecification'
import SkuList from './FormItemSkuList'

export const FormItemSkuList = SkuList

export const specification_mixin = {
  components: {
    FormItemSkuList,
    PddSpecification
  },
  data() {
    return {
      specifications: [],
      skuImgOnlyPreview: true, // sku的预览图是否只能预览不能编辑
      skuList: [],
      skuTableCols: [ // 这是默认的规格详情table的配置，字段不同请到对应使用的vue文件中覆盖
        {prop: 'skuOuterId', attrs: {label: '商品编码'}, input: {type: 'text', onlyTable: true}},
        {prop: 'salesPrice', attrs: {label: '销售价'}, input: {type: 'number'}},
        {prop: 'marketPrice', attrs: {label: '市场价'}, input: {type: 'number'}},
        {prop: 'stock', attrs: {label: '库存'}, input: {type: 'number', attrs: {precision: 0}}},
        {prop: 'weight', attrs: {label: '重量(kg)'}, input: {type: 'number'}},
      ]
    }
  },
  computed: {
    computedValueForm() {
      let form = {}
      this.skuTableCols.forEach(item => {
        if (item.input) {
          form[item.prop] = 0
        }
      })
      return form
    },
  },
  watch: {
    specifications: {
      // 监听规格信息生成规格详情列表
      handler(v) {
        // debugger;
        const self_form_key = this.mixinsFormKey ? this.mixinsFormKey : 'self_form'
        const self_skuSpecifications_key = this.skuSpecificationsKey ? this.skuSpecificationsKey : 'skuSpecifications'
       
        if (v.length < 1 || !this[self_form_key]) {
          this.skuList = []
          return
        }
        // 有没创建规格值的的规格就不生成skulist
        let hasNoValues = false
        if (!v.filter(item => item.name).length) {
          hasNoValues = true
        }
        v.filter(item => item.name).forEach(item => {
          if (hasNoValues) return
          if (item.values.length) return
          if (item.values.filter(i => i.checked).length) return
          hasNoValues = true
        })
        // debugger;

        if (hasNoValues) {
          this.skuList = []
        } else {
          let _skuList = []
          const that = this
          function forEach(arr, index = 0, c_arr = []) {
            // 取到最后一层开始作业务逻辑
            if (arr.length === index) {
              // 若有值为空或未勾选不做任何处理
              if (c_arr.some(item => (!item.value || !item.checked))) {
                return;
              }
              // debugger;
              let _skuid = c_arr.map(item => item.valueKey).join('-') // 生成skuid
              if (that.specNum <= 1) {
                _skuid = c_arr[0].valueKey;
              }
              const _skuSpecifications = c_arr.map((item,index) => { //生成sku明细
                const _sp = {
                  checked: that.getChecked(v[index].nameKey, item.valueKey, v),
                  name: v[index].name,
                  value: item.value,
                  nameKey: v[index].nameKey,
                  valueKey: item.valueKey
                }
                if (that.isPdd) { // pdd 
                  _sp.propId = item.propId;
                  _sp.propValueId = item.propValueId;
                }
                if (that.isJd) {
                  // 京东平台需要存储propId 及 propValueId
                  const _spItem = that._mix_getSpItem(v[index].nameKey, item.valueKey, v)
                  if (_spItem) {
                    _sp.propId = _spItem.propId
                    _sp.propValueId = _spItem.propValueId
                  }
                }
                // 非sku预览图只可预览的表单且当前商品图片规格没改过，需要在原self_form里面skuList字段取图片数据
                // 而不是通过_skuSpecifications中取
                if (!that.skuImgOnlyPreview && !window.__spcificationImg_changed) {
                  const selfSku = that.skuList.find(sku => sku._skuid === _skuid)
                  if (selfSku) {
                    _sp.imageUrl = selfSku.imageUrl || selfSku[self_skuSpecifications_key][0].imageUrl || ''
                  } else {
                    _sp.imageUrl = item.imageUrl || ''
                  }
                } else {
                  if (window.__spcificationImg_changed) {
                    // 规格图改变且是当前sku有包含改变的规格字段就取规格图
                    if (_skuid.indexOf(window.__spcificationImg_changed) > -1) {
                      _sp.imageUrl = item.imageUrl || ''
                    } else {
                      // 否则取当前skuList中的图片
                      const thisSku = that.skuList.find(sku => sku._skuid === _skuid)
                      if (thisSku) {
                        _sp.imageUrl = thisSku[self_skuSpecifications_key][0].imageUrl
                      } else {
                        _sp.imageUrl = item.imageUrl || ''
                      }
                    }
                  } else {
                    _sp.imageUrl = item.imageUrl || ''
                  } 
                }   
                return _sp
              })
              // 1. 现在当前skuList中找有无数据
              // 2. 在self_form中找有无数据
              // 3. 生成一个全新skuitem
              
              let skuItem;
              const copyImgToSkuImg = (sItem) => { // pdd 需要更新skuImg
                if (that.isPdd) {
                  const imgUrl = _skuSpecifications[0] && _skuSpecifications[0].imageUrl;
                  if (imgUrl) {
                    sItem.skuImg = imgUrl;
                  }
                }
              }
              // --- 1
              const thisSku = that.skuList.find(sku => sku._skuid === _skuid)
              if (thisSku) {
                skuItem = {
                  ...thisSku
                }
                skuItem[self_skuSpecifications_key] = _skuSpecifications
                copyImgToSkuImg(skuItem)
                _skuList.push(skuItem)
                return
              }
              // --- 2
              if (that.selectSpecList.length) {
                const selfSku = that.selectSpecList.find(sku => {
                  let skuSkuId = sku.spec1 ? `${sku.spec0}-${sku.spec1}` : `${sku.spec0}`;
                  return skuSkuId === _skuid
                })
                if (selfSku) {
                  skuItem = {
                    id: selfSku.id,
                    multiPrice: '',
                    outSkuSn: selfSku.skuOuterId,
                    quantity: selfSku.stock,
                    singlePrice: '',
                    skuImg: selfSku.skuSpecifications[0].imageUrl,
                    weight: selfSku.weight,
                    _skuid: selfSku._skuid,
                  }
                  skuItem[self_skuSpecifications_key] = _skuSpecifications
                  copyImgToSkuImg(skuItem)
                  _skuList.push(skuItem)
                  return
                }
              }
              // --- 3
              skuItem = {
                _skuid,
                ...JSON.parse(JSON.stringify(that.computedValueForm)),
              }
              skuItem[self_skuSpecifications_key] = _skuSpecifications
              copyImgToSkuImg(skuItem)
              _skuList.push(skuItem)

              return;
            }

            // 取出一层
            let currItem = arr[index]
            // 此层值循环
            currItem.values.forEach(c => {
              // 每个值再递归取
              forEach(arr, index + 1, c_arr.concat(c))
            })
          }
          forEach(v.filter(item => item.name))
          this.skuList = _skuList
          if (!this[self_form_key].skuList.length) {
            this[self_form_key].skuList = JSON.parse(JSON.stringify(_skuList));
          }
          window.__spcificationImg_changed = ''
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 根据nameKey、valueKey获取checked值
    getChecked(nameKey, valueKey, specifications) {
      try {
        return specifications.find(item => item.nameKey === nameKey).values
        .find(item => item.valueKey === valueKey).checked
      } catch (error) {
        console.log('----getChecked', error)
        return false
      }
    },
    // 根据nameKey、valueKey获取指定的规格值对象
    _mix_getSpItem(nameKey, valueKey, specifications) {
      try {
        return specifications.find(item => item.nameKey === nameKey).values
        .find(item => item.valueKey === valueKey)
      } catch (error) {
        return null
      }
    },
    // 校验规格信息
    validateSpecifications(specifications) {
      if (!this.skuList.length) {
        this.$message.error('请补充商品规格及规格明细')
        return false
      }

      const errorReg = /[|,\^]+/ // 规格名与值不允许输入 ^|, 三种符号

      let errmsg = null;

      specifications = specifications || this.specifications;
      for (let index = 0; index < specifications.length; index++) {
        const specification = specifications[index];
        if (!specification.name) {
          this.$message.error('请补充规格名')
          return false
        }
        if (this.needValiSymbol && errorReg.test(specification.name)) {
          this.$message.error(`规格名:${specification.name} 请勿包含^|,符号`)
          return false
        }

        

        let valiArr = [] // 有效的规格值
        for (let vindex = 0; vindex < specification.values.length; vindex++) {
          const value = specification.values[vindex]
          if (!value.checked) {
            // 未勾选不校验
            continue
          }
          if (this.isPdd) {
            // pdd 必须有propId
            if (!value.propId && !value.parentSpecId) {
              this.$message.error(`规格名列表项不包含 规格名[${specification.name}], 请修改规格名[${specification.name}]`)
              return false
            }
          }
          if (!value.value) {
            // 校验规格值不能为空
            errmsg = `${specification.name}规格下的规格值未完善`
            this.$message.error(errmsg)
            return false
          }
          if (this.needValiSymbol && errorReg.test(value.value)) {
            this.$message.error(`规格值:${value.value} 请勿包含^|,符号`)
            return false
          }
          if (this.specification_needImg && index === 0 && !value.imageUrl) {
            // 该表单是否需要图片 && 第一个规格需要校验图片 && 图片不能为空
            errmsg = `${specification.name}规格下的图片未完善`
            this.$message.error(errmsg)
            return false
          }
          if (valiArr.includes(value.value)) {
            errmsg = `${value.value}规格值重复`
            this.$message.error(errmsg)
            return false
          }
          valiArr.push(value.value)
        }
        // if (valiArr.length > 50) {
        //   errmsg = `${specification.name}的规格值数量超过50`
        //   this.$message.error(errmsg)
        //   return false
        // }
        continue;
      }
      return this.validateSkuList()
      // return true;
    },
    // 校验skuList
    validateSkuList() {
      // 校验空值
      const validateVoid = (value, prop) => {
        if (value === "" || value === undefined) {
          return `${prop.label}请勿输入空值`
        }
        return false
      }

      // 需要校验的props
      const props = this.skuTableCols.filter(item => item.input).map(item => {
        return {
          ...item,
          prop: item.prop,
          label: item.attrs.label,
          validator: item.input.validator ? item.input.validator : !item.attrs.noRequired ? validateVoid : null
        }
      })
      const self_skuSpecifications_key = this.skuSpecificationsKey ? this.skuSpecificationsKey : 'skuSpecifications';
      // debugger;
      for(let index = 0; index < this.skuList.length; index++) {
        const sku = this.skuList[index]
        if (this.isPdd) { // pdd 要校验 预览图
          const skuSpec0 = sku[self_skuSpecifications_key] && sku[self_skuSpecifications_key][0]
          if (!skuSpec0 || !skuSpec0.imageUrl) {
            this.$message.error('请完善价格库存列表预览图!');
            return false;
          }
        }
        // for (let pidex = 0; pidex < props.length; pidex++) {
        //   const prop = props[pidex];
        //   if (prop.validator) {
        //     const errmsg = prop.validator(sku[prop.prop], prop)
        //     if (errmsg) {
        //       this.$message.error(errmsg)
        //       return false
        //     }
        //   }
        // }
      }
      return true
    },
    // 清空数据
    // 由于dialog关闭未销毁实例，会有数据缓存问题，需要在弹窗关闭时调用一下
    clear_specification() {
      this.specifications = []
    },
    // 获取规格与规格明细数据
    getSpecificationData(specifications) {
      specifications = specifications || JSON.parse(JSON.stringify(this.specifications))
      const self_form_key = this.mixinsFormKey ? this.mixinsFormKey : 'self_form'
      const self_skuSpecifications_key = this.skuSpecificationsKey ? this.skuSpecificationsKey : 'skuSpecifications'

      const checkedValueKeys = []

      // 平台资料需要对规格的checkbox做一些处理
      if (!this.isBaseInfo) {
        specifications.forEach((item, index) => {
          item.values.forEach((v, vi) => {
            // 如果未勾选，需要获取之前的数据进行填充
            if (v.checked) {
              checkedValueKeys.push(v.valueKey)
            }
          })
        })
      }

      const copyImgToSkuImg = (sItem) => { // pdd 需要更新skuImg
          const _skuSpecifications = sItem.skuSpecifications;
          const imgUrl = _skuSpecifications[0] && _skuSpecifications[0].imageUrl;
          if (imgUrl) {
            sItem.skuImg = imgUrl;
          }
      }
      let skuList = this.skuList.map(item => {
          // 源sku不动 只更改checked值
          let sku = {
            ...item
          }
          sku[self_skuSpecifications_key].forEach(sp => {
            if (checkedValueKeys.includes(sp.valueKey)) {
              sp.checked = true
            } else {
              sp.checked = false
            }
          })
          if (this.isPdd) {
            copyImgToSkuImg(sku);
          }
          return sku
      })
      return [specifications, skuList]
    }
  }
}

export default PddSpecification
